type CapacitorGlobal = {
  isNativePlatform?: () => boolean;
  getPlatform?: () => string;
};

function cap(): CapacitorGlobal | undefined {
  return (window as Window & { Capacitor?: CapacitorGlobal }).Capacitor;
}

export function isNative(): boolean {
  return cap()?.isNativePlatform?.() ?? false;
}

export function getPlatform(): 'ios' | 'android' | 'web' {
  const p = cap()?.getPlatform?.();
  if (p === 'ios' || p === 'android') return p;
  return 'web';
}
